import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Icon, M } from 'design-system-web';
import { TranslationKeys } from 'localization';
import styles from './CreateCoverageHoursPanel.scss';

type IssueTypeInfoMessageProps = {
  infoKey: TranslationKeys;
  categoryValue: string;
};

export function IssueTypeInfoMessage({
  infoKey,
  categoryValue,
}: IssueTypeInfoMessageProps) {
  const { t } = useTranslation();

  return (
    <Flex gap={2} align="flex-start" className={styles.infoMessage}>
      <Icon
        name="info-circle"
        set="FontAwesome"
        type="far"
        className={styles.infoIcon}
      />
      <M className={styles.infoText}>
        {t(infoKey, { category: categoryValue })}
      </M>
    </Flex>
  );
}
